import styled, { css } from 'styled-components';
import { IconButton } from 'ui/button';
import { body2, borderRadius, colors, spacing } from 'ui/theme';

export const SwitchContainer = styled.div`
  display: inline-flex;
  gap: ${spacing.threeEights};
`;

export const StyledErrorLocaleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const BadgeWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  ${body2}
  color: ${colors.textInteractive};
  path {
    /*
     * There's currently some styles from the select component that is overriding the fill color.
     * this is a "temporary" fix to ensure the badge is the correct color.
     * @see https://github.com/Iterable/iterable-frontend/blob/ecc6d6b1a10a4331e49a151159f402c3e22dfac1/src/ui/selects/Selects.styles.ts#L181-L184 for example
     */
    fill: ${colors.textInteractive}!important;
  }
`;

export const LocaleLabelContainer = styled.div<{ $hasError: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  color: ${({ theme, $hasError }) =>
    $hasError ? theme.colors.primaryColors.red100 : theme.colors.textColors.textPrimary};
`;

export const DefaultLocaleSubLabel = styled.p`
  color: ${colors.textSecondary};
`;

export const LocaleActionMenuTooltipContent = styled.div<{ isEnabled: boolean }>`
  align-items: center;
  box-sizing: border-box;
  cursor: ${({ isEnabled }) => (isEnabled ? 'not-allowed' : 'pointer')};
  display: grid;
  grid-column-gap: ${spacing.half};
  grid-template-columns: ${spacing.plusHalf} auto;
  justify-items: start;
  text-decoration: none;
  white-space: nowrap;
  width: 100%;
`;

export const StyledOverflowButton = styled(IconButton)`
  &&& {
    margin-right: -${spacing.eighth};
    border-radius: 0 ${borderRadius.md} ${borderRadius.md} 0;
  }
`;

export const ComboButton = styled.div<{ $isReadOnly: boolean }>`
  display: flex;
  #trigger-locale-switcher-dropdown {
    border-right: ${({ $isReadOnly }) =>
      $isReadOnly ? '' : 'none'}; /** '' is defaulting to the original value here */
    border-bottom-right-radius: ${({ $isReadOnly }) =>
      $isReadOnly ? '' : '0'}; /** '' is defaulting to the original value here */
    border-top-right-radius: ${({ $isReadOnly }) =>
      $isReadOnly ? '' : '0'}; /** '' is defaulting to the original value here */
  }

  ${({ $isReadOnly }) =>
    $isReadOnly &&
    css`
      border-color: ${colors.purple50} !important;
      border-bottom-right-radius: ${spacing.quarter};
      border-top-right-radius: ${spacing.quarter};
    `}

  > *:last-child > span > button {
    border-bottom-left-radius: 0;
    border-left: none;
    border-top-left-radius: 0;
  }
`;
